var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-toggle',{style:(_vm.themeStyle),attrs:{"color":_vm.color,"disable":_vm.disable,"label":_vm.label,"left-label":_vm.left,"val":_vm.val,"value":_vm.value,"data-test-id":"fib-toggle"},on:{"input":_vm.handleChange}})}
var staticRenderFns = []

export { render, staticRenderFns }